'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/wishlist'));
    // added to main.js for global 'add to cart' from minicart
    // processInclude(require('./product/quickViewPdp'));
});
